import React from "react";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import Cw8Show from "components/cw8/Cw8Show";

export const AutorPublicationsShow: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "autorPublication";
    return (
        <Cw8Show
            resourceName = {resourceName}
        ></Cw8Show>
    );
};